import { __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Controller } from 'react-hook-form';
import { ControlGroup } from '@sravni/react-design-system';
import { Slider } from '@sravni/react-shared-components/lib/Slider';
import { FORM_FIELDS } from '../../constants/form.js';
import '../../constants/sources.js';
import { SelectInput } from '../Form/Select/select.input.js';
import modules_6008a9bf from './ConditionsSelector.module.scss.js';

var ConditionsSelector = function (_a) {
    var sliderAmount = _a.sliderAmount, control = _a.control, setSliderAmount = _a.setSliderAmount, formParams = _a.formParams;
    return (jsxs(ControlGroup, { children: [jsx(Controller, { name: FORM_FIELDS.AMOUNT, control: control, render: function (_a) {
                    var field = _a.field;
                    return (jsx(Slider, __assign({}, field, { value: sliderAmount, onChange: setSliderAmount, className: modules_6008a9bf.slider, fieldClassName: modules_6008a9bf.sliderField, min: formParams.amount.min, max: formParams.amount.max, step: formParams.amount.step, withSlider: false, hideBorderValues: true })));
                } }), jsx(Controller, { name: FORM_FIELDS.PERIOD, control: control, render: function (_a) {
                    var field = _a.field;
                    return (jsx(SelectInput, __assign({}, field, { label: "\u041D\u0430 \u0441\u0440\u043E\u043A", className: modules_6008a9bf.select, options: formParams.periodOptions, withCrossIcon: false })));
                } })] }));
};

export { ConditionsSelector };
//# sourceMappingURL=ConditionsSelector.js.map
